(function () {
    var debug = false;
    var opt = {
        beforeLoad: function(element) {
            var id = $(element).attr('id');
            //console.log("loading " + id  + "...");
        },
        ajaxLoader: function (ele) {
            var url = $(ele).data("from");
            if (url == undefined) {
                console.error("URL undefined");
                return;
            }
            $.get(url, function (data){
                ele.before(data);
                ele.remove();
            });
        }
    };

    var clog = function (msg) {
        if (debug) {
            console.log("[CM] " + msg);
        }

    };

    try {
        clog("start lazy.");
        $(".lazy").lazy(opt);
    } catch (e) {
        clog("error to start lazy, try again. ");
        clog("error: " + e.name + ", msg:" + e.message);

        $.getScript("/js/jquery.lazy.min.js", function () {
            clog("try to restart lazy.");
            try {
                 $(function() {
                    clog( "document is ready. try to start lazy" );
                    $(".lazy").lazy(opt);
                });
            } catch (e) {
                console.error("Restart lazy failed.");
                throw new Error("Can not start layzload plugin.");
            }
        });
    }
})();

/***
 * jquery的ready和window.onload并不能保证lazy插件被载入
 */
/**
$(function() {
    console.log( "ready!" );
    initLazy();
});**/
/**
window.οnlοad=function(){
    console.log( "window ready!" );
    initLazy();
};**/
//initLazy();


// WEBPACK FOOTER //
// ./resources/assets/js/common.js